import { render, staticRenderFns } from "./MenuButton.vue?vue&type=template&id=5f066e4d&scoped=true"
import script from "./MenuButton.vue?vue&type=script&lang=ts"
export * from "./MenuButton.vue?vue&type=script&lang=ts"
import style0 from "./MenuButton.vue?vue&type=style&index=0&id=5f066e4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f066e4d",
  null
  
)

export default component.exports